// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import BookNowButton from "./BookNowButton";

// const Navbar = ({ navbarRef }) => {

//   const [isSticky, setIsSticky] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsSticky(window.scrollY > 10);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <nav ref={navbarRef} className={`navbar navbar-expand-lg ${isSticky ? "sticky" : ""}`} id="navbar">
//       <div className="container justify-content-between d-flex">
//         <Link className="navbar-brand fw-bold" to="/">
//           <img src="/assets/images/logo.jpg" alt="logo" />
//         </Link>

//         <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         <div className="collapse navbar-collapse justify-content-lg-center" id="navbarNav">
//           <ul className="navbar-nav">
//             <li className="nav-item">
//               <Link className="nav-link" to="/yacht-rental-dubai">Yachts</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/yacht-rental-services-dubai">Services</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/rental-yacht-events-dubai">Events</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/blogs">Blogs</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/about-blueharbour-yacht-rentals">About Us</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/contact-us">Contact Us</Link>
//             </li>
//             <li className="nav-item d-md-none d-block mb-5">
//               <Link to="/contact-us"><button className="book_now_btn btn">Book Now</button></Link>
//               {/* <BookNowButton buttonText="Book Now" buttonClass="book_now_btn btn" /> */}
//             </li>
//           </ul>
//         </div>

//         <div className="d-lg-block d-none">
//           <Link to="/contact-us"><button className="book_now_btn">Book Now</button></Link>
//           {/* <BookNowButton buttonText="Book Now" buttonClass="book_now_btn" /> */}
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Button } from "react-bootstrap";

const CustomNavbar = ({ navbarRef }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      ref={navbarRef}
      expand="lg"
      className={`${isSticky ? "sticky shadow-sm" : ""}`}
      // fixed="top"
      id="navbar"
    >
      <Container className="justify-content-between">
        <Navbar.Brand as={Link} to="/">
          <img src="/assets/images/white-logo.png" alt="logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav"  onClick={() => setIsNavCollapsed(!isNavCollapsed)}  />
        <Navbar.Collapse id="navbar-nav" in={!isNavCollapsed} className="justify-content-lg-center">
          <Nav className="">
            <Nav.Link as={Link} to="/yacht-rental-dubai" onClick={() => setIsNavCollapsed(true)}>Yachts</Nav.Link>
            <Nav.Link as={Link} to="/yacht-rental-services-dubai" onClick={() => setIsNavCollapsed(true)}>Services</Nav.Link>
            <Nav.Link as={Link} to="/rental-yacht-events-dubai" onClick={() => setIsNavCollapsed(true)}>Events</Nav.Link>
            <Nav.Link as={Link} to="/blogs" onClick={() => setIsNavCollapsed(true)}>Blogs</Nav.Link>
            <Nav.Link as={Link} to="/about-blueharbour-yacht-rentals" onClick={() => setIsNavCollapsed(true)}>About Us</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" onClick={() => setIsNavCollapsed(true)}>Contact Us</Nav.Link>
          </Nav>
          <div className="d-lg-none d-block mb-2">
            <Button as={Link} to="https://api.whatsapp.com/send?phone=971566265785" className="book_now_btn btn" variant="none">Book Now</Button>
          </div>
        </Navbar.Collapse>

        <div className="d-none d-lg-block">
          <Button as={Link} to="https://api.whatsapp.com/send?phone=971566265785" className="book_now_btn" variant="none">Book Now</Button>
        </div>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
